/**
 * Error codes reported by the DepartmentController
 */
export var DepartmentErrorCode;
(function (DepartmentErrorCode) {
    /**
     * Indicates an attempt to create or rename a department with/to a name which already exists within the court system
     */
    DepartmentErrorCode["DuplicateDepartmentName"] = "department/DuplicateDepartmentName";
    /**
     * The department was not found
     */
    DepartmentErrorCode["DepartmentNotFound"] = "department/DepartmentNotFound";
})(DepartmentErrorCode || (DepartmentErrorCode = {}));
